/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab, Paper } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoctorAvailability from './DoctorAvailability';
import DoctorAvailabilityOverview from './DoctorAvailabilityOverview';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`doctor-tabpanel-${index}`}
      aria-labelledby={`doctor-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function DoctorManagementDashboard() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Gestión de Doctores
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Administra horarios y disponibilidad médica
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              minHeight: 72,
              textTransform: 'none',
              fontSize: '1rem',
            },
          }}
        >
          <Tab
            icon={<SettingsIcon />}
            label="Gestionar Disponibilidad"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab
            icon={<VisibilityIcon />}
            label="Vista General"
            iconPosition="start"
            sx={{ gap: 1 }}
          />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <DoctorAvailability />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <DoctorAvailabilityOverview />
        </TabPanel>
      </Paper>
    </Container>
  );
}
